// Import Bootstrap JavaScript
import bootstrap from 'bootstrap'

// Import global SCSS styles
import '../scss/main.scss';

import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

// Import custom modules
import initEmailAddress from "./modules/init_email_address";
import initBanner from "./modules/tt-banner";
import initCardSlider from "./modules/tt-card-slider";
import initCounter from "./modules/tt-counter";
import initGallery from "./modules/tt-gallery";
import initLogoSlider from "./modules/tt-logo-slider";
import initTabsMedia from "./modules/tt-tabs-media";
import initTextMedia from "./modules/tt-text-media";

// Example for using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);

// Initialize modules when DOM is ready
window.addEventListener('DOMContentLoaded', () => {
    initEmailAddress('.tt-email');
    initBanner();
    initCardSlider();
    initCounter();
    initGallery();
    initLogoSlider();
    initTabsMedia();
    initTextMedia();
});
